(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.upcast = factory());
}(this, (function () { 'use strict';

// Guard a 'type' argument

var guardTypeArg = function (type) {
    if (typeof type !== 'string') {
        throw new TypeError('Invalid argument: type is expected to be a string');
    }
};

// Guard a 'type' argument
var guardTypeHandler = function (type) {
    if (typeof type !== 'function') {
        throw new TypeError('Invalid argument: handler is expected to be a function');
    }
};

var Upcast = function Upcast() {
    var this$1 = this;

    // Define aliases
    this.alias = {
        a: 'array',
        arr: 'array',
        array: 'array',
        b: 'boolean',
        bool: 'boolean',
        boolean: 'boolean',
        null: 'null',
        n: 'number',
        num: 'number',
        number: 'number',
        o: 'object',
        obj: 'object',
        object: 'object',
        s: 'string',
        str: 'string',
        string: 'string',
        undefined: 'undefined'
    };

    // Default casters
    this.cast = {
        array: function array(val) {
            return [val];
        },
        boolean: function boolean(val) {
            return Boolean(val);
        },
        function: function function$1(val) {
            return function () {
                return val;
            };
        },
        null: function () { return null; },
        number: function (val) { return Number(val); },
        object: function (val) { return new Object(val); }, // eslint-disable-line no-new-object
        string: function (val) { return String(val); },
        undefined: function () { return undefined; }
    };

    // Special casters
    this.cast.array.null = function () { return []; };
    this.cast.array.undefined = function () { return []; };
    this.cast.array.string = function (val) {
        if (val === 'false' || val === 'true') {
            return [this$1.cast.boolean.string(val)];
        }
        return val.split('');
    };
    this.cast.boolean.array = function (val) { return val.length > 0; };
    this.cast.boolean.string = function (val) {
        if (val === 'false') {
            return false;
        }
        return this$1.cast.boolean(val);
    };
    this.cast.number.array = function (val) { return this$1.to(this$1.to(val, 'string'), 'number'); };
    this.cast.number.string = function (val) {
        if (val === 'false' || val === 'true') {
            val = this$1.cast.boolean.string(val);
        }
        var num = Number(val, 10);
        return isNaN(num) ? 0 : num;
    };
    this.cast.number.undefined = function () { return 0; };
    this.cast.string.array = function (val) { return val.join(''); };
    this.cast.string.null = function () { return ''; };
    this.cast.string.undefined = function () { return ''; };
    this.cast.object.string = function (val) {
        if (val === 'false' || val === 'true') {
            val = this$1.cast.boolean.string(val);
        }
        return this$1.cast.object(val);
    };
};

// Add custom cast
Upcast.prototype.add = function add (type, handler) {
    guardTypeArg(type);
    guardTypeHandler(handler);

    this.cast[type] = handler.bind(this);
};

// Resolve type aliases
Upcast.prototype.resolve = function resolve (val) {
    return this.alias[val] || val;
};

// Get an object's type
Upcast.prototype.type = function type (val) {
    if (val === null) {
        return 'null';
    }
    if (Object.prototype.toString.call(val) === '[object Array]') {
        return 'array';
    }
    return typeof val;
};

// Check whether an object is of a certain type
Upcast.prototype.is = function is (val, type) {
    guardTypeArg(type);
    return this.type(val) === this.resolve(type);
};

// Cast an object to a given type
Upcast.prototype.to = function to (val, type) {
    guardTypeArg(type);

    // Get type and return if already correct
    type = this.resolve(type);
    var from = this.type(val);
    if (type === from) {
        return val;
    }

    // Get a caster and cast!
    if (!this.cast[type]) {
        return val;
    }
    var caster = this.cast[type][from] || this.cast[type];
    return caster(val);
};

var src = new Upcast();

return src;

})));
